import { inject, Injectable } from '@angular/core';
import { ModalService } from 'src/app/components/modals/modal.service';
import { RvshareWindowsModalComponent } from '../components/rvshare-windows-modal/rvshare-windows-modal.component';

@Injectable({
  providedIn: 'root',
})
export class RvshareWindowsModalService {
  private modalService = inject(ModalService);

  // Resolves whether the person went on to download or launch the app. The modal service rejects a dismissal, which
  // here is just an answer.
  show(): Promise<boolean> {
    return this.modalService
      .showLargeDialog(
        RvshareWindowsModalComponent,
        {},
        {
          panelClass: ['rvshare-windows-modal'],
          ariaLabelledBy: RvshareWindowsModalComponent.TITLE_ID,
        },
      )
      .then(
        () => true,
        () => false,
      );
  }
}
